<dx-load-panel
  shadingColor="rgba(0,0,0,0.4)"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  message="Calcul en cours..."
>
</dx-load-panel>

<div class="custom-toolbar">
  <div class="custom-toolbar-element custom-button-container-left">
    <yo-help lang="fr" [file]="pathFile" [width]="800"></yo-help>
    <div class="d-flex flex-row align-items-center">
      <i class="fas fa-book-reader mg-r-5 mg-l-15"></i> R&Eacute;SUM&Eacute;
    </div>
  </div>
  <div class="custom-button-container-right">
    <yo-button
      tooltip="Appliquer les modifications aux ligne(s) selectionnée(s)"
      label="Traitement en masse"
      iconClass="fas fa-edit"
      [theme]="ButtonThemeEnum.DEFAULT"
      [disabled]="!selectedConditionnementList?.length"
      (onClick)="openMassiveTreatmentDialog()">
    </yo-button>
    <yo-button
      iconClass="fas fa-box-open"
      [theme]="ButtonThemeEnum.DEFAULT"
      class="mr-1"
      (onClick)="printEditionConditionnement()"
      tooltip="Générer le bon de conditionnement">
    </yo-button>
  </div>
</div>

<div>
  <label class="badge badge-secondary">
    {{ 'PLAN DE PRODUCTION - ' + planProduction | uppercase }}
  </label>
</div>

<div id="grid-container">
  <dx-data-grid
    (onEditorPreparing)="onEditorPreparing($event)"
    id="tab-calcul-conditionnement-details"
    [dataSource]="data"
    keyExpr="id"
    columnResizingMode="widget"
    [allowColumnReordering]="true"
    [hoverStateEnabled]="true"
    [allowColumnResizing]="true"
    [rowAlternationEnabled]="true"
    [showRowLines]="true"
    [showBorders]="true"
    autoExpandAll="false"
    (onSelectionChanged)="onSelectionChanged($event)"
  >
    <dxo-selection
      [selectAllMode]="true"
      [showCheckBoxesMode]="'always'"
      mode="multiple"
    ></dxo-selection>

    <dxo-editing mode="cell" [allowUpdating]="true" [allowAdding]="false" [allowDeleting]="false"></dxo-editing>
    <dxo-search-panel [visible]="true"></dxo-search-panel>
    <dxo-toolbar>
      <dxi-item location="before">
        <div *dxTemplate>
          <dx-button
            [text]="this.expandAll ? 'Plier' : 'Déplier'"
            width="136"
            (onClick)="changeCollapseAll()"
          >
          </dx-button>
        </div>
      </dxi-item>
      <dxi-item name="searchPanel"></dxi-item>
    </dxo-toolbar>

    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-grouping [autoExpandAll]="expandAll"></dxo-grouping>
    <dxo-search-panel [visible]="true"></dxo-search-panel>
    <dxo-pager [showPageSizeSelector]="true" [showNavigationButtons]="false" [allowedPageSizes]="[20, 50, 100, 200]"
               [visible]="true" [showInfo]="true" infoText="{2} ligne(s) de paramétrage"></dxo-pager>

    <dxi-column dataField="produit" caption="Produit" [allowEditing]="false"
                [filterOperations]="['contains']"
                [groupIndex]="1">
    </dxi-column>
    <dxi-column dataField="declinaison" caption="Declinaison" [allowEditing]="false"
                [filterOperations]="['contains']" alignment="left">
    </dxi-column>
    <dxi-column dataField="prestation" caption="Prestation" [allowEditing]="false"
                [filterOperations]="['contains']">
    </dxi-column>
    <dxi-column dataField="regime" caption="Régime" [allowEditing]="false"
                [filterOperations]="['contains']">
    </dxi-column>
    <dxi-column dataField="uniteProduction" caption="Unité de production" [allowEditing]="false"
                [filterOperations]="['contains']">
    </dxi-column>

    <dxi-column dataField="pointLivraison" caption="Point de livraison" [allowEditing]="false"
                [filterOperations]="['contains']">
    </dxi-column>
    <dxi-column dataField="repas" caption="Repas" [allowEditing]="false"
                [filterOperations]="['contains']" width="100px">
    </dxi-column>
    <dxi-column dataField="qteConditionnement" caption="Qté" [allowEditing]="false"
                [filterOperations]="['contains']" width="70px" alignment="left">
    </dxi-column>
    <dxi-column dataField="conditionnement" caption="Conditionnement" [allowEditing]="false"
                [filterOperations]="['contains']">
    </dxi-column>
    <dxi-column dataField="variante" caption="Variante" [allowEditing]="false"
                [filterOperations]="['contains']">
    </dxi-column>

    <dxi-column dataField="effectifNourri" caption="Effectif Nourri" [allowEditing]="false"
                [filterOperations]="['contains']">
    </dxi-column>

    <dxi-column dataField="total" caption="Total" [allowEditing]="false"
                [filterOperations]="['contains']" cellTemplate="totalTemplate" alignment="left">
    </dxi-column>

    <dxi-column dataField="dateConditionnement" caption="Date conditionnement" dataType="date"
                [filterOperations]="['contains']" cellTemplate="dateConditionnementTemplate"
                headerCellTemplate="updateHeaderCellTemplate"
                [allowEditing]="true"
    >
    </dxi-column>


    <dxi-column dataField="dateFabrication" caption="Date fabrication" dataType="date" [allowEditing]="false"
                [filterOperations]="['contains']" cellTemplate="dateFabricationTemplate">
    </dxi-column>

    <dxi-column dataField="atelier" caption="Atelier" [allowEditing]="false"
                [filterOperations]="['contains']">
    </dxi-column>

    <dxi-column dataField="reste" caption="Reste" dataType="boolean" width="70px" [allowEditing]="false"
                [filterOperations]="['contains']">
    </dxi-column>

    <dxi-column dataField="regroupement" caption="Regroupé" dataType="boolean" width="100px" [allowEditing]="false"
                [filterOperations]="['contains']">
    </dxi-column>

    <dxi-column dataField="idRegroupementPlat"
                caption="Sous-recette"
                dataType="boolean"
                width="100px"
                [allowEditing]="false"
                [calculateCellValue]="isSubRecipe"
                [filterOperations]="['contains']">
    </dxi-column>

    <dxi-column dataField="hasSubRecipe" caption="Composé de sous-recette(s) conditionnée(s) à part" dataType="boolean" width="100px" [allowEditing]="false"
                [filterOperations]="['contains']">
    </dxi-column>

    <div *dxTemplate="let cell of 'totalTemplate'">
      {{ utils.roundFloat(cell.value, 2) }} {{ cell.row.data.uniteConditionnement }}
    </div>

    <dxo-pager
      [showNavigationButtons]="false"
      [visible]="true"
      [showInfo]="true"
      infoText="{2} résumé(s)">
    </dxo-pager>

    <div *dxTemplate="let cell of 'dateConditionnementTemplate'">
      <i *ngIf="isDateFermeturePonctuelle(cell.row.data)" class="fa-solid fa-calendar red-calendar"
         [title]="'Fermeture du conditionnement'">
      </i>
      {{ utils.convertddMMYYYYSlashVersion(cell.row.data.dateConditionnement) }}
    </div>

    <div *dxTemplate="let cell of 'updateHeaderCellTemplate'">
      <div [title]="'Colonne modifiable : ' + cell.column.caption">
        {{ cell.column.caption }}
      </div>
    </div>

    <div *dxTemplate="let cell of 'dateFabricationTemplate'">
      {{ utils.convertddMMYYYYSlashVersion(cell.row.data.dateFabrication) }}
    </div>

  </dx-data-grid>
</div>

<div id="footer-step" class="custom-button-container">
  <yo-button (onClick)="previousStep()"
             label="Précédent"
             tooltip="Plan de production"
             iconClass="fas fa-angle-left"
    [theme]="ButtonThemeEnum.DEFAULT">
  </yo-button>
</div>

<dx-popup
  title="Traitement en masse des conditionnement"
  [showTitle]="true"
  [height]="'auto'"
  [width]="'90wh'"
  (onHiding)="closeDialogMassiveTreatment()"
  [(visible)]="displayDialogMassiveTreatment"
  [resizeEnabled]="true"
  [showCloseButton]="true"
>

  <div class="row mg-b-10">
    <div class="col-md-7">
      <label>Date de conditionnement </label>
    </div>
    <div class="col-md-5">
      <dx-date-box #dateBoxConditionnement id="dateConditionnement" [(ngModel)]="dateConditionnement" type="date"></dx-date-box>
    </div>
  </div>
  <div class="row mg-b-10">
    <div class="col-md-12 text-right">
      <yo-button iconClass="fas fa-check"
        [theme]="ButtonThemeEnum.SAVE"
                 class="mg-r-5"
                 [disabled]="!dateConditionnement"
                 (onClick)="applyMassiveTreatment()"></yo-button>
      <yo-button iconClass="fas fa-times" (onClick)="closeDialogMassiveTreatment()"
                 [theme]="ButtonThemeEnum.DELETE"></yo-button>
    </div>
  </div>
</dx-popup>


<yo-print-settings-editions-conditionnement
  [idPlanProduction]="idPlanProduction">
</yo-print-settings-editions-conditionnement>
<yo-display-calcul-conditionnement-erreur></yo-display-calcul-conditionnement-erreur>
